module.exports = __webpack_public_path__ + "static/media/locatoriconheader.2c56043d.svg";